import React from 'react';
import { HOW_IT_WORKS } from '../mock/mock';

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-20 lg:py-24 bg-gradient-to-b from-white via-purple-50/30 to-white">
      <div className="max-w-[1440px] mx-auto px-5 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white border border-purple-200 soft-shadow">
            <span className="text-[11px] font-bold tracking-wider text-[#5F259F] uppercase">How It Works</span>
          </div>
          <h2 className="mt-4 text-4xl lg:text-5xl font-extrabold text-slate-900 leading-tight">
            Live in <span className="gradient-text">4 simple steps</span>
          </h2>
          <p className="mt-4 text-slate-600">From enquiry to your first digital payment — we make it effortless.</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5 relative">
          {/* connector line */}
          <div className="hidden lg:block absolute top-10 left-[12%] right-[12%] h-0.5 bg-gradient-to-r from-purple-200 via-violet-300 to-purple-200" />

          {HOW_IT_WORKS.map((step, i) => (
            <div key={step.step} className="relative bg-white rounded-3xl border border-purple-100 p-6 hover-lift soft-shadow">
              <div className="absolute -top-5 left-6 w-12 h-12 rounded-2xl gradient-primary flex items-center justify-center text-white font-black text-lg premium-shadow">
                {step.step}
              </div>
              <div className="mt-8">
                <h3 className="text-lg font-extrabold text-slate-900">{step.title}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
